import * as React from 'react';

import usePermissions from 'hooks/usePermissions';
import type { EventProcedureStepAPIType } from 'security-app/hooks/api/eventProceduresAPI.types';

import StepActionButton from './StepActionButton';

type Props = {
  config: EventProcedureStepAPIType['action']['config'];
  actionUrl: string;
};

function StepGoToDashboard({ config, actionUrl }: Props) {
  const { dashboard_id } = config;
  const { isPermitted } = usePermissions();
  const disabled = !isPermitted(`dashboards:read:${dashboard_id}`);

  return (
    <StepActionButton
      hint={disabled ? "You don't have access to see this dashboard" : undefined}
      title="Go to Dashboard"
      to={disabled ? null : actionUrl}
      disabled={disabled}
    />
  );
}

export default StepGoToDashboard;
